import React from 'react';
import { createGlobalStyle } from 'styled-components';

import { applyPartnerTheme } from '../themes.helpers';
import { Brand } from '../themes.types';

interface ColorThemeProps {
  brand: Brand;
}

export const ColorTheme = ({ brand }: ColorThemeProps) => {
  applyPartnerTheme(brand);
  switch (brand) {
    case 'coop':
      return <CoopColors />;
    case 'akademikerne':
    case 'danskeBank':
    default:
      return null;
  }
};

const CoopColors = createGlobalStyle`
  :root {
  --color-primary: #003366; //primary
  --color-primary-variant: #2e6aa6; //primaryVariant
  --color-primary-pressed: #003366; //primaryPressed

  --color-white: #fff;

  --color-surface-border:#BFCDD4;
  --color-surface-variant: #DCF0FA;
  --color-surface-variant-border: #2E6AA6;
  }
  `;
